import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import { PROGRAM_USERS_LIST, PROGRAM_USERS_LIST_SUCCESS, PROGRAM_USERS_LIST_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall';

function* getProgramUsers({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/program-users`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: PROGRAM_USERS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: PROGRAM_USERS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PROGRAM_USERS_LIST_ERROR, payload: error });
  }
}

export function* watchProgramUsers() {
  yield takeEvery(PROGRAM_USERS_LIST, getProgramUsers);
}

function* programUserSaga() {
  yield all([fork(watchProgramUsers)]);
}

export default programUserSaga;
